import axios from 'axios'
import { router } from '../router';

export default {
  SET_SIDEBAR ({ commit }, sidebarItems) {
    commit('SET_SIDEBAR', sidebarItems)
  },
  async REQUEST_TOKEN ({ commit }, credentials) {
    try{
      let res = await axios.post('/api/auth/login', credentials)
      let { given_name, middle_name, family_name, user_id, image } = res.data.profile
      let { token } = res.data
      let userRole = await axios.get('/api/auth/me/role', 
        { headers: { 'Authorization': `Bearer ${token}` }})
        
      let userObject = { name: `${given_name} ${family_name}`, user_id, image  }
      let userDetails = {}
      if(userRole.data.user_role === 0){
        userDetails = { ...userObject, role: 'Administrator' }
      } else if(userRole.data.user_role === 1){
        userDetails = { ...userObject, role: 'Instructor' }
      } else if(userRole.data.user_role === 2){
        userDetails = { ...userObject, role: 'Student' }
      }
        
      commit('SET_TOKEN', token)
      commit('SET_USER_DETAILS', userDetails)

      // Return if admin, instructor or student
      return Promise.resolve(userRole.data.user_role)
    }catch(e){
      commit('REMOVE_TOKEN')
      return Promise.reject(e)
    }
  },
  async LOGGED_OUT ({ commit }) {
    // try{
    //   let logout = await axios.post('/api/auth/logout')
    //   console.log(logout)
      // commit('REMOVE_TOKEN')
      router.push('/')
    // }catch(e){

    // }
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js